//import resume from '../assets/pdf/resume.pdf'
import pic from '../assets/png/me.png'

export const headerData = {
    name: 'Semegn Mulugeta',
    title: "Software Developer",
    desciption:"Hello there 👋, I'm a passionate web and mobile application developer. I enjoy learning new things and solving challenging problems. I am always exploring the latest technologies and frameworks, and I thrive on turning complex ideas into practical solutions.",
    image: pic,
    resumePdf: 'https://drive.google.com/file/d/1lzlv_kqwf-kGh1DA4tUbvxAXtbswLLCc/view?usp=drivesdk'
}
